import { render, staticRenderFns } from "./GKField.vue?vue&type=template&id=58258783&scoped=true&"
import script from "./GKField.vue?vue&type=script&lang=js&"
export * from "./GKField.vue?vue&type=script&lang=js&"
import style0 from "./GKField.vue?vue&type=style&index=0&id=58258783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58258783",
  null
  
)

export default component.exports